// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button.is-plain[data-v-eb2898ea]{--el-button-active-text-color:var(--el-color-primary);--el-button-active-border-color:var(--el-color-primary)}.el-button--primary.is-plain[data-v-eb2898ea]{--el-button-border-color:var(--el-color-primary-light-3)}.el-link.el-link--primary[data-v-eb2898ea]:hover{color:var(--el-color-primary-light-3)}[data-v-eb2898ea] .el-link--inner{display:flex;justify-content:space-between;padding-bottom:10px}", ""]);
// Exports
module.exports = exports;
